/* ============================================================
   AVORA HOME — Product Delivery Estimate (live)
   Renders the shopper's destination flag, a live estimated
   arrival window based on the published shipping policy.

   The 7–10 business-day window combines 2 business days of
   processing with 5–8 business days in transit. It deliberately
   has no unsupported daily cut-off or urgency timer.
   ============================================================ */
(function () {
  'use strict';

  var CONFIG = {
    minDays: 7,
    maxDays: 10
  };

  /* ISO 3166-1 alpha-2 → emoji flag (regional indicator symbols). */
  function isoToFlag(code) {
    if (!code || code.length !== 2) return '';
    var offset = 0x1F1E6 - 65; // 'A' = 65
    return String.fromCodePoint(code.codePointAt(0) + offset) +
           String.fromCodePoint(code.codePointAt(1) + offset);
  }

  function init() {
    var root = document.querySelector('.avora-delivery');
    if (!root) return;

    /* ----- Destination country + flag ----- */
    var code = (root.getAttribute('data-country-code') || '').toUpperCase();
    var name = root.getAttribute('data-country-name') || '';
    var flagEl = root.querySelector('.avora-delivery__flag');
    var nameEl = root.querySelector('.avora-delivery__country-name');
    if (flagEl) {
      var flag = isoToFlag(code);
      if (flag) flagEl.textContent = flag;
    }
    if (nameEl) nameEl.textContent = name || window.AvoraI18n.text('your location');

    /* ----- "Change" opens the header country selector (desktop only) ----- */
    var changeBtn = root.querySelector('.avora-delivery__change');
    var csTrigger = document.querySelector('.cs__trigger');
    if (changeBtn && csTrigger && csTrigger.offsetParent !== null) {
      changeBtn.hidden = false;
      changeBtn.addEventListener('click', function () {
        var cs = document.querySelector('.cs');
        if (cs && cs.scrollIntoView) cs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { csTrigger.click(); }, 350);
      });
    }

    /* ----- Policy-aligned arrival window ----- */
    var datesEl = root.querySelector('[data-delivery-dates]');
    if (datesEl) datesEl.textContent = CONFIG.minDays + '–' + CONFIG.maxDays + window.AvoraI18n.text(' business days');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
